import React, { Component } from 'react';
import * as $ from 'jquery';
import { Trans, translate } from 'react-i18next';
import CoworkSearch from './CoworkSearch.js';
import CoworkCard from './CoworkCard.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';

import HelpContainer from '../HelpContainer';
import GoBackButton from '../../components/GoBackButton'

let cancelToken;
let state;
let tokenSession;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class CoworkedContainer extends Component {
    getInitState = () => {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return {
            date: moment(tomorrow, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            error: "",
            isSearching: false,
            reservationId: "",
            IsFast: false,
            IsRoom: false,
            book: null,
            cuidad: [],
            city: "",
            duration: "",
            coworks: [],
            start_day: null,
            finsh_day: null,
            start_day_fomart: null,
            finsh_day_fomart: null,
        };
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        if (props.city) {
            state.cuidad = props.cuidad;
            state.city = props.city;
        }
        state.reservationId = "";
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.reservationId !== prevState.reservationId) {
            const getBookRoom = () => this.getBooK({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.state.reservationId,
            });

            this.setState({
                IsFast: true,
            }, getBookRoom);
        }

        if (this.state.book !== prevState.book) {
            $('#btnSuccess').click()
        }
    }

    reload = () => {
        if (this.props.city) {
            this.getCoworks({
                city_id: this.state.city ? this.state.city : this.props.city,
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession()
            });
            this.setState({
                duration: "1"
            })
        }
        this.getCitys({
            token_id: this.props.getTokenId()
        });
    }

    getCitys = (params) => {
        this.props.post(
            "/getCities",
            params,
            (response) => this.didGetCity(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getCoworks = (params) => {
        this.props.post_store(
            "/getCoworks",
            params,
            (response) => this.didGetCoworks(response),
            (error) => this.handleErrorResponse(error),
            cancelToken,
            () => this.setState({ isSearching: false })
        );
    }

    didBookCowork = (response) => {
        this.setState({ reservationId: response });
    }

    didGetCoworks = (response) => {
        this.setState({
            coworks: response,
            isSearching: false,
        });
    }

    didGetCity = (response) => {
        this.setState({ cuidad: response });
    }

    handleErrorResponse = (response) => {
        alert(response);
    }

    handleDateChange = (date) => {
        const new_date = moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
        var enddate = moment(new_date)
        var start_day_fomart = moment(new_date).format('YYYY-MM-DD')

        if (this.state.duration === '2') {
            enddate.add(1, 'weeks').format('YYYY-MM-DD')
        } else if (this.state.duration === '3') {
            enddate.add(1, 'months').format('YYYY-MM-DD')
        }
        var finsh_day_fomart = moment(enddate).format('YYYY-MM-DD')
        this.setState({
            date: new_date,
            start_day: new_date,
            finsh_day: enddate,
            start_day_fomart: start_day_fomart,
            finsh_day_fomart: finsh_day_fomart,
        });
    }

    handleDurationChange = (event) => {
        var startdate = this.state.start_day ? this.state.start_day : this.state.date;
        var enddate = moment(startdate)
        var start_day_fomart = moment(startdate).format('YYYY-MM-DD')
        if (event.target.value === '2') {
            enddate.add(1, 'weeks').format('YYYY-MM-DD')
        } else if (event.target.value === '3') {
            enddate.add(1, 'months').format('YYYY-MM-DD')
        }
        var finsh_day_fomart = moment(enddate).format('YYYY-MM-DD')
        this.setState({
            duration: event.target.value,
            finsh_day: enddate,
            start_day_fomart: start_day_fomart,
            finsh_day_fomart: finsh_day_fomart,
        });
    }

    handleClearError = () => {
        this.setState({ error: "" });
    }

    handleRoomSearch = (event) => {
        event.preventDefault();

        this.setState({
            error: "",
            isSearching: true
        });

        this.getCoworks({
            city_id: this.state.city ? this.state.city : this.props.city,
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });
    }

    handleTimeChange = (event) => {
        this.setState({
            time: event.target.value,
        });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    renderRoomSearch = () => {
        return (
            <CoworkSearch
                date={this.state.date}
                duration={this.state.duration}
                error={this.state.error}
                handleDateChange={this.handleDateChange}
                handleDurationChange={this.handleDurationChange}
                handleRoomSearch={this.handleRoomSearch}
                handleCityChange={this.handleCityChange}
                handleClearError={this.handleClearError}
                isSearching={this.state.isSearching}
                time={this.state.time}
                cuidad={this.state.cuidad}
                city={this.state.city}
                start_day={this.state.start_day}
                finsh_day={this.state.finsh_day} />
        );
    }

    renderRoomCard = () => {
        return (
            <CoworkCard
                coworks={this.state.coworks}
            />
        )
    }

    rebderHelperContainer = () => {
        return (
            <HelpContainer />
        )
    }

    render() {
        const { t } = this.props;
        return (
            <div className="content-resvations">
                <div className="container-resvations-title">
                    <GoBackButton />
                    <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
                </div>
                <div>
                    <div className="content-resvations-search">
                        {this.renderRoomSearch()}
                    </div>
                    <div className="content-resvations-content">
                        {this.state.coworks ? (
                            <div id="coworks">
                                {this.renderRoomCard()}
                            </div>
                        ) : null}
                    </div>
                    <div className="gap form-group">
                        {/* <Link to={URI_VENTA_EN_LINEA}>
                            <button
                                className="btn btn-primary"
                                type="button"
                            >
                                <span>
                                    Regresar
                                </span>
                            </button>
                        </Link> */}
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => $('#btnSuccessHelp').click()}
                        >
                            <span>
                                <Trans>dashboard.contact.holder_message</Trans>
                            </span>
                        </button>
                    </div>
                    {this.rebderHelperContainer()}
                </div>
            </div>
        )
    }
}

export default translate('common')(CoworkedContainer);


// WEBPACK FOOTER //
// ./src/store/Cowork/CoworkContainer.js